import { validatePersonalDetails } from './personal-details';
import { validateBankDetails } from './bank-details';
import { validateSuperannuation } from './superannuation';
import { validateTFNDeclaration } from './tfn-declaration';
import { validateWorkRights } from './work-rights';

export async function validate(field) {
  const sectionName = field?.name?.split('.')[0];
  switch (sectionName) {
    case 'personalDetails':
      return validatePersonalDetails(field);
    case 'bankDetails':
      return validateBankDetails(field);
    case 'superannuation':
      return validateSuperannuation(field);
    case 'tfnDeclaration':
      return validateTFNDeclaration(field);
    case 'workRights':
      return validateWorkRights(field);
  }
}
